export default __webpack_public_path__ + "static/media/calendar.907eec5f.svg";